export interface GlobalThisExtended {
	STICKY_VERSION_STATE?: string;
}
declare const globalThis: GlobalThisExtended;

export const getStickyVersionsState = (): string => {
	const stickyVersionState = globalThis.STICKY_VERSION_STATE ?? 'na';

	return stickyVersionState;
};
